import * as React from "react";
import { View } from "./lib/View";
import styles from "./PageOneHeader.module.css";

export function PageOneHeader(props: { children: any }) {
  return <View style={styles.root}>{props.children}</View>;
}
